var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1818 40.5L33.2727 50.7273L56.8182 26.8636M66.9091 50.7273C63.5455 54.1364 71.1136 63.5114 66.9091 67.7727C62.7045 72.0341 53.4545 64.3636 50.0909 67.7727C46.7273 71.1818 45.0455 78 40 78C34.9545 78 33.2727 71.1818 29.9091 67.7727C26.5455 64.3636 17.2955 72.0341 13.0909 67.7727C8.88636 63.5114 16.4545 54.1364 13.0909 50.7273C9.72727 47.3182 3 45.6136 3 40.5C3 35.3864 9.72727 33.6818 13.0909 30.2727C16.4545 26.8636 8.88636 17.4886 13.0909 13.2273C17.2955 8.96591 26.5455 16.6364 29.9091 13.2273C33.2727 9.81818 34.9545 3 40 3C45.0455 3 46.7273 9.81818 50.0909 13.2273C53.4545 16.6364 62.7045 8.96591 66.9091 13.2273C71.1136 17.4886 63.5455 26.8636 66.9091 30.2727C70.2727 33.6818 77 35.3864 77 40.5C77 45.6136 70.2727 47.3182 66.9091 50.7273Z",
    stroke: "#FFF",
    strokeWidth: 5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckStar);
export default __webpack_public_path__ + "static/media/check_star.aa1a09cf.svg";
export { ForwardRef as ReactComponent };